<template>
  <div>
    <!-- <div class="leftnews">
      <div class="swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in articles" :key="item.id">
          <a :href="item.url?item.url:`/news/info/${item.plateid}/${item.uuid}`" :target="item.url?'_blank':'_self'">
            <img :src="`${IP_TEST}/uploads/${item.picsrc}`" width="622" height="404" alt="" />
          </a>
        </div>
      </div>
    </div>
    </div> -->
    
    <!-- <div class="infonews" >
      <div class="info">
        <div class="itembottom">
          <div class="item">
            <span v-for="(item,index) in INFO_LIST" :class="{ first: index === 0, active: activeInfoIndex === index}"
              :key="index" v-text="item" @click="changeInfo(index,item)">
            </span>
            <router-link :to="`/news/views/${plateIdInfo}`">更多</router-link>
          </div>
          <div class="itemlist">
            <ul class="list">
              <li v-for="item in infos" :key="item.id">
                <i></i>
                <router-link :to="`/news/info/${item.plateid}/${item.uuid}`" :title="item.title">{{ item.title}}
                </router-link>
                <span>{{ item.addtime | datefilter }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
    <el-carousel :interval="5000" arrow="always" height="546px">
      <el-carousel-item v-for="item in articles" :key="item.id">
        <a :href="item.url?item.url:`/news/info/${item.plateid}/${item.uuid}`" :target="item.url?'_blank':'_self'">
          <img :src="`${IP_TEST}/uploads/${item.picsrc}`" width="1300" height="546" alt="" />
          <h1 >{{ item.title }}</h1>
        </a>
      </el-carousel-item>
    </el-carousel>
  </div>
  
</template>

<script>
import { getPicNews,getNewsViews  } from '@/request/get'
import {  INFO_NEWS, INFO_LIST,IP_TEST } from '@/config'
export default {
  name: "Banner",
  data() {
    return {
      articles: [],
      IP_TEST,
      activeInfoIndex: 0,
      INFO_LIST: INFO_LIST,
      INFO_NEWS: INFO_NEWS,
      plateIdInfo: "",
      infos:[]
    }
  },
  created() {
    this.getPicNews();
    this.changeInfo(0, this.INFO_NEWS); 
  },
  filters: {
    datefilter(value) {
      return value.slice(0,10);
    }
  },
  methods: {
    _sortByTop(arr) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].top == "1") {
          arr.unshift(arr[i]);
          arr.splice(i + 1, 1);
          break;
        }
      }
      return arr;
    },
    createSwiper() {
      // eslint-disable-next-line no-undef
      new Swiper('.swiper', {
        direction: 'horizontal',
        loop: true,
        autoplay: 5000,
        speed: 500,
        grabCursor: true,
        onSlideChangeStart: swiper => this.activeIndex = swiper.activeIndex,
        // 如果需要分页器
        pagination: '.swiper-pagination',
        // // // 如果需要前进后退按钮
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        // // 如果需要滚动条
        // scrollbar: '.swiper-scrollbar',
      })
    },
    async getPicNews() {
      let result = await getPicNews();
      result = result.data;
      this.articles = result && this._sortByTop(result);
    },
    async getNewsViews(uuid) {
      let result = await getNewsViews(uuid, 1,6);
      result = result.data;
      this.infos = result || [];
    },
    changeInfo(index, name) {
      this.activeInfoIndex = index
      let { plates } = this.$store.state;
      let plate = plates.filter(plate => plate.name == name);
      this.plateIdInfo = plate[0].uuid;
      this.getNewsViews(this.plateIdInfo);
    },
  }
};
</script>
<style scoped>
.leftnews{
  width: 632px;
  height: 383px;
  /* background: #fff; */
  display: inline-block;
}
.swiper{
  position: relative;
  width: 620x;
    margin-left: 10px;
  height: 371px;
  overflow: hidden;
  background: #fff;
  /* margin: 0 10px 0 10px; */
 
}
.swiper-slide {
  text-align: left;
  font-size: 18px;
  /* background: #fff; */
  width: 416px;
  
  line-height: 344px;
}
.infonews{
  width: 646px;
  height: 362px;
  background-color: rgba(255,255,255,0.5);
  display: inline-block;
  position: absolute;
  margin-left: 22px;
}
.infonews>.info>.itembottom{
  width: 645px;
}
.infonews>.info>.itembottom{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
}
.infonews>.info>.itembottom>.item{
  position: relative;
  margin-bottom: 6px;
  height: 55px;
  border-bottom: 1px solid #ECECEC;
  display: flex;
  justify-content: start;
  text-align: center;
  background: #F3F3F3;
  border-bottom: solid 3px #0157C6;
}
.infonews>.info>.itembottom>.item>span {
  height: 58px;
  /* margin-right: 53px; */
  font-size: 20px;

  font-weight: bold;
  color: #B3B3B3;
  width: 188px;
  line-height: 58px;
}
.infonews>.info>.itembottom>.item>span.active {
  color: #FFFFFF;
  
  /* border-bottom: 2px solid #489860; */
  height: 64px;
background: url(/static/img/tab-bg.png);
}
.infonews>.info>.itembottom>.item>a{
  position: absolute;
  padding-right: 25px;
  right: 38px;
  height: 58px;
  font-size: 14px;
  
  font-weight: 500;
  font-weight: normal;
  color: #999999;
  line-height: 58px;
  background: url(/static/img/gengduo.png) no-repeat 12px 12px;
  background-position: center right;
}
.infonews>.info>.itembottom>.itemlist{
  width: 608px;
  height: 436px;
  display: flex;
  justify-content: start;
  /* padding:0 38px 0 38px; */
}
.infonews>.info>.itembottom>.itemlist>.list{
    display: flex;
    flex-direction: column;
    justify-content: start;
    overflow: hidden;
}
.infonews>.info>.itembottom>.itemlist>.list>li{
  height: 40px;
  display: flex;
  justify-content: start;
  align-items: center;
  border-bottom: 1px solid #D9D9D9;
}

.infonews>.info>.itembottom>.itemlist>.list>li:before {
    background: red;
    border-radius: 50%;
    content: "";
    display: inline-block;
    height: 8px;
    width: 8px;
}

.infonews>.info>.itembottom>.itemlist>.list>li>a{
  width: 444px;
  height: 53px;
  margin-right: 55px;
  font-size: 18px;

  font-weight: 500;
  color: #333;
  line-height: 53px;
  overflow: hidden;
      word-break: break-all;
    /* display: -webkit-box; */
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
-webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    margin-left: 10px;
    /* overflow: hidden; */
}

.infonews>.info>.itembottom>.itemlist>.list>li>span {
  width: 150px;
  height: 53px;
  font-size: 16px;
  font-weight: 500;
  color: #999999;
  line-height: 53px;
  text-align: right;
}
/deep/ .el-carousel--horizontal{
  overflow: hidden;
}
</style>


